import { render, staticRenderFns } from "./ThongBaoForm.vue?vue&type=template&id=41d68dcd&"
import script from "./ThongBaoForm.vue?vue&type=script&lang=js&"
export * from "./ThongBaoForm.vue?vue&type=script&lang=js&"
import style0 from "./ThongBaoForm.vue?vue&type=style&index=0&id=41d68dcd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports